var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventSmallGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.83 8.657-3.506 3.587.828 5.066a.605.605 0 0 1-.224.577.543.543 0 0 1-.593.045L10 15.54l-4.335 2.392a.538.538 0 0 1-.592-.045.605.605 0 0 1-.224-.578l.828-5.066L2.17 8.657a.612.612 0 0 1-.142-.605.573.573 0 0 1 .454-.403l4.846-.738 2.167-4.608c.19-.404.82-.404 1.01 0l2.167 4.608 4.846.738a.572.572 0 0 1 .454.403.612.612 0 0 1-.142.605Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.5,
    y1: 15.5,
    x2: 18.226,
    y2: 1.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSmallGrayIcon);
export default __webpack_public_path__ + "static/media/event-small-gray-icon.c61d7e146fc5011ffba7eea3e7c3d30f.svg";
export { ForwardRef as ReactComponent };